import marked from 'marked';

export default {
  props: {
    source: String,
  },
  computed: {
    rendered() {
      return marked(this.source);
    },
  },
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/markdown/Markdown.js